import Dropdown from "@shared/v2/Dropdown";
import IconButton from "@shared/v2/IconButton";
import { DateRangeDropdown } from "@shared/v2/DateRangeDropdown";
import { Section } from "../BusinessDashboard/Section";
import { CurrentYear } from "./helpers";

const Header = ({
  year,
  setYear,
  isPreviousYear,
  standardValue,
  previousYearSegment,
  customRange,
  reportConfig,
  onStandardChange,
  onPreviousYearChange,
  setFullscreen,
}) => {
  return (
    <Section>
      <div className="tw-flex tw-justify-between">
        <span className="tw-text-28px tw-text-gray-75">Activity Leaderboard</span>
        <div className="tw-flex tw-gap-[16px]">
          <Dropdown
            className="tw-w-[98px] tw-z-50"
            options={YearOptions}
            value={YearOptions.find(({ value }) => value === year)}
            onChange={({ value }) => { setYear(value); }}
          />
          {isPreviousYear ? (
            <DateRangeDropdown
              key={`previous-year-${year}`}
              mode="previous-year"
              year={year}
              initialValue={previousYearSegment}
              onChange={onPreviousYearChange}
              dropdownClassName="tw-z-50"
            />
          ) : (
            <DateRangeDropdown
              key="standard"
              mode="standard"
              config={reportConfig}
              initialValue={standardValue}
              initialCustomRange={customRange}
              onChange={onStandardChange}
              dropdownClassName="tw-z-50"
            />
          )}
          <IconButton
            size="medium"
            schema="transparent"
            onClick={setFullscreen}
            title="Fullscreen"
          >
            <i className="fa fa-arrows-alt" />
          </IconButton>
        </div>
      </div>
    </Section>
  );
};

export default Header;

const StartingYear = 2017;

const YearOptions = (() => {
  const range = CurrentYear - StartingYear;
  const options = [];
  for (let i = range; i > -1; i--) {
    const value = (StartingYear + i);
    options.push({ label: value, value });
  }

  return options;
})();
